import Button from "./button"

const Another = ({ instance, url }) => {
  return (
    <div key={instance.startDate} className="center border p-3">
      <dl>
        <dt>Pradžia</dt>
        <dd> {instance.startDate}</dd>
        <dt>Pabaiga</dt>
        <dd> {instance.endDate}</dd>
        <dt>Kaina</dt>
        <dd>
          {instance.offers.priceCurrency}
          {instance.offers.price}
        </dd>
        <dt>Kur</dt>
        <dd> {instance.courseMode}</dd>
      </dl>

      <Button href={url} />
    </div>
  )
}
export default Another
